// extracted by mini-css-extract-plugin
module.exports = {"description":"Closed_description__yQmKx","edit-btn":"Closed_edit-btn__2COnP","form-item-wrapper":"Closed_form-item-wrapper__3KnaW"};